var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Aside',{attrs:{"ativo":_vm.ativo,"id":"asideImage"},on:{"close":function($event){_vm.ativo = false}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"img"},[_c('img',{staticClass:"image",attrs:{"src":_vm.image.image}})]),(_vm.image.text !== '')?_c('p',{domProps:{"innerHTML":_vm._s(_vm.image.text)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }